
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/work/generated/ui/shared/due-dates/jst/missingDueDateDialog';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<div>\n  <p>\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("calendar.missing_due_date_dialog")
  },data:data},helper ? helper.call(depth0, "not_everyone_will_be_assigned_this_item_661e7bd9", "Not everyone will be assigned this item!", options) : helperMissing.call(depth0, "t", "not_everyone_will_be_assigned_this_item_661e7bd9", "Not everyone will be assigned this item!", options)))
    + "\n  </p>\n  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("calendar.missing_due_date_dialog")
  },data:data},helper ? helper.call(depth0, "would_you_like_to_continue_a1ed1b87", "Would you like to continue?", options) : helperMissing.call(depth0, "t", "would_you_like_to_continue_a1ed1b87", "Would you like to continue?", options)))
    + "\n\n  <div class=\"button-container form-actions\">\n    <button type=\"button\" class=\"btn\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("calendar.missing_due_date_dialog")
  },data:data},helper ? helper.call(depth0, "go_back_ed239e69", "Go Back", options) : helperMissing.call(depth0, "t", "go_back_ed239e69", "Go Back", options)))
    + "</button>\n    <button type=\"button\" class=\"btn btn-primary\">\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("calendar.missing_due_date_dialog")
  },data:data},helper ? helper.call(depth0, "continue_ac067716", "Continue", options) : helperMissing.call(depth0, "t", "continue_ac067716", "Continue", options)))
    + "\n    </button>\n  </div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  